import React from 'lib/react';
import { BarChart } from '@mui/x-charts/BarChart';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { useDrawingArea, LinePlot } from '@mui/x-charts';
import useMediaQuery from 'hooks/useMediaQuery';
import { makeStyles } from 'lib/components';
import { MarkPlot } from '@mui/x-charts/LineChart';

const StyledPath = styled('path')(
  () => ({
    fill: 'none',
    stroke: '#B4BAC7',
    shapeRendering: 'crispEdges',
    strokeWidth: 1,
    pointerEvents: 'none',
  }),
);

function BorderTop() {
  // Get the drawing area bounding box
  const {
    left, top, width,
  } = useDrawingArea();

  return (
    <StyledPath
      d={`M ${left} ${top} l ${width} 0`}
      color="secondary"
    />
  );
}

const useStyles = makeStyles(() => ({
  tooltip: {
    '& *': {
      fontFamily: 'Noto Sans !important',
    },
    '& .MuiChartsTooltip-mark': {
      border: 'none',
      boxShadow: 'none',
    },
  },
}));

function AnalyticsBarChart(props) {
  const {
    sx, slotProps, tooltip, children, ...rest
  } = props;

  const classes = useStyles();
  const isMobile = useMediaQuery(640);

  return (
    <BarChart
      sx={{
        '& *': {
          fontFamily: 'Noto Sans',
        },
        '& .MuiChartsAxis-tickLabel, .MuiChartsAxis-label': {
          fill: '#82899C !important',
        },
        '& .MuiChartsAxis-line': {
          stroke: '#B4BAC7 !important',
        },
        '& .MuiChartsGrid-line': {
          stroke: '#B4BAC7 !important',
        },
        '& .MuiChartsAxis-right .MuiChartsAxis-label': {
          transform: 'translateX(20px)',
        },
        ...sx,
      }}
      grid={{ vertical: true }}
      margin={{
        top: 8,
        right: isMobile ? 0 : 60,
        bottom: 20,
        ...(isMobile) ? { left: 0 } : { },
      }}
      slotProps={{ legend: { hidden: true }, ...slotProps }}
      tooltip={{ classes: { root: classes.tooltip }, ...tooltip }}
      {...rest}
    >
      <BorderTop />
      <LinePlot />
      <MarkPlot />
      {children}
    </BarChart>
  );
}

AnalyticsBarChart.defaultProps = {
  sx: {},
  slotProps: {},
  tooltip: {},
  // #genai Preserve the existing optional-children behavior while satisfying PropTypes linting.
  children: null,
};

AnalyticsBarChart.propTypes = {
  sx: PropTypes.shape(),
  slotProps: PropTypes.shape(),
  tooltip: PropTypes.shape(),
  // #genai: add missing props validation for 'children' (Sonar S6774)
  children: PropTypes.node,
};

export default AnalyticsBarChart;
